import { Dispatch, SetStateAction } from 'react';
import { CaptionText, P3 } from '../../../styles/FontStyles';
import { WalletBox } from '../Portfolio.styled';
import { Button, Flexed } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { Icon, IconPortfolioWallet } from '../../../styles/Icons';
import { useDisconnect } from 'wagmi';

interface WithdrawWalletProps {
  walletAddress: string | undefined;
  connectWallet: () => Promise<void>;
  isButtonVisible: boolean;
  isConnected: boolean;
  setWalletAddressSign: Dispatch<SetStateAction<string>>;
}

export const WithdrawWallet = ({
  walletAddress,
  isButtonVisible,
  isConnected,
  setWalletAddressSign
}: WithdrawWalletProps) => {
  const { disconnect } = useDisconnect();
  return (
    <WalletBox>
      {
        <Flexed center>
          <Icon color={color.colors.secondary100} mr='-5'>
            <IconPortfolioWallet />
          </Icon>

          <P3
            color={color.colors.neutral900}
            bold
            style={{ wordBreak: 'break-all' }}>
            {walletAddress}
          </P3>
        </Flexed>
      }

      {isButtonVisible && (
        <Button
          negative
          ml='10'
          w='auto'
          h='36px'
          onClick={() => {
            setWalletAddressSign('');
            disconnect();
          }}>
          Disconnect
        </Button>
      )}
    </WalletBox>
  );
};
